import {
	convertibleTextInput,
	FormItem,
	InputWithMoreInfo,
	ReorderableList,
	Select,
	SelectItem,
	TextInput,
	ValidationError
} from "client/Components";
import { IInputAttachable, IValueInputAttachable } from "client/Forms/attachable";
import { integerConverter } from "client/Forms/converters";
import { localize } from "client_legacy/ndaw/culture";
import { isUpdateYammerTabModelWithFeedId } from "./EditYammerTile";
import { UpdateYammerTabModel, YammerFeedKind } from "client/Api/Workspace/workspace";

const NumberInput = convertibleTextInput<number | null>(integerConverter);

const tabKindOptions: readonly SelectItem<YammerFeedKind>[] = [
	{ text: localize("_HomeFeed"), value: YammerFeedKind.Home },
	{ text: localize("_AllCompany"), value: YammerFeedKind.AllCompany },
	{ text: localize("_OtherGroup"), value: YammerFeedKind.OtherGroup }
];

type EditYammerTabItemProps = {
	tabHandler: IValueInputAttachable<UpdateYammerTabModel>;
	onRemoveTab: () => void;
	onInfoDialogOpen: () => void;
};

export const EditYammerTabItem = (props: EditYammerTabItemProps) => {
	const {
		tabHandler,
		onRemoveTab,
		onInfoDialogOpen,
	} = props;

	return (
		<ReorderableList.PanelItem
			header={
				<Select
					options={tabKindOptions}
					{...tabHandler.for("kind")
						.attachToSelect()}
					menuTitle={localize("_Source")}
				/>
			}
			onRemove={onRemoveTab}
		>
			<ValidationError
				{...tabHandler.for("kind")
					.attachToValidationError()}
			/>
			{tabHandler.whenType(isUpdateYammerTabModelWithFeedId,
				handlerWithFeedId => (
					<FeedIdInput
						onMoreInfo={onInfoDialogOpen}
						inputAttachable={handlerWithFeedId.for("feedId")}
					/>
				)
			)}
			<FormItem
				label={localize("_TabName")}
			>
				<TextInput {...tabHandler
					.for("name")
					.attachToTextInput()}
				/>
				<ValidationError {...tabHandler
					.for("name")
					.attachToValidationError()}
				/>
			</FormItem>
		</ReorderableList.PanelItem>
	);
};

EditYammerTabItem.displayName = "EditYammerTabItem";

type FeedIdInputProps = {
	onMoreInfo: () => void;
	inputAttachable: IInputAttachable<number | null>;
};

const FeedIdInput = (props: FeedIdInputProps) => {
	const { onMoreInfo, inputAttachable } = props;

	return (
		<FormItem label={localize("_GroupsFeedId")}>
			<InputWithMoreInfo
				onMoreInfo={onMoreInfo}
			>
				<NumberInput {...inputAttachable.attachToTextInput()} />
			</InputWithMoreInfo>
			<ValidationError
				{...inputAttachable.attachToValidationError()}
			/>
		</FormItem>
	);
};

FeedIdInput.displayName = "FeedIdInput";